// Fallback reports — shown on the Blog/reader before Supabase is configured & seeded.
// Once the DB has data, the live Supabase records replace these.
// `year`/`quarter` are FISCAL (Jul–Jun); `year` is the year the fiscal year ENDS in.
// See src/utils/fiscal.js. Image/PDF filenames keep their original names.

export const FALLBACK_REPORTS = [
  {
    id: "2026-q4",
    year: 2026,
    quarter: "Q4",
    date: "Apr – Jun 2026",
    pages: 7,
    title: "Beyond the Shock: Building Resilience in a Fragmented Global Economy",
    abstract: "“We cannot direct the wind, but we can adjust our sails.” A quarter shaped by geopolitical tension and a restrictive fiscal environment — met with AI-assisted analytics and workflow automation.",
    authors: "Bilal Arshad & Afzaal Sadiq",
    image: "/img/reports/2026-q4.jpg",
    file: "/reports/softwood-management-report-2026-q4.pdf"
  },
  {
    id: "2026-q3",
    year: 2026,
    quarter: "Q3",
    date: "Jan – Mar 2026",
    pages: 7,
    title: "From Stabilization to Shock Management",
    abstract: "The external environment is uncertain, but internal execution will define winners. Quality, efficiency, and clarity are no longer advantages — they are requirements for survival.",
    authors: "Mudassar Ali & Hassan Ali",
    image: "/img/reports/2026-q1.jpg",
    file: "/reports/softwood-management-report-2026-q1.pdf"
  },
  {
    id: "2026-q2",
    year: 2026,
    quarter: "Q2",
    date: "Oct – Dec 2025",
    pages: 18,
    title: "World Outlook 2026: Growth, Policy & Geopolitical Risk",
    abstract: "The road ahead is arduous and will require intense work to succeed. A global outlook on slower growth, policy shifts, and the geopolitical forces reshaping textile demand.",
    authors: "Hasan Sharif & Muhammad Sabeeh ul Hassan",
    image: "/img/reports/2025-q4.jpg",
    file: "/reports/softwood-management-report-2025-q4.pdf"
  },
  {
    id: "2026-q1",
    year: 2026,
    quarter: "Q1",
    date: "Jul – Sep 2025",
    pages: 4,
    title: "Pakistan Economic & Export Outlook",
    abstract: "“And that each person will only have what they endeavoured towards.” (Qur'an 53:39) A quarter of volatile exports, a U.S. tariff cut, and flood-hit cotton.",
    authors: "Saqib Nazir & Firasat Noor",
    image: "/img/reports/2025-q3.jpg",
    file: "/reports/softwood-management-report-2025-q3.pdf"
  },
  {
    id: "2025-q4",
    year: 2025,
    quarter: "Q4",
    date: "Apr – Jun 2025",
    pages: 6,
    title: "From Cotton Exporter to Cotton Importer",
    abstract: "“With faith, discipline, and selfless devotion to duty, there is nothing worthwhile that you cannot achieve.” — Muhammad Ali Jinnah",
    authors: "Tanveer Hassan & Faisal Javad",
    image: "/img/reports/2025-q2.jpg",
    file: "/reports/softwood-management-report-2025-q2.pdf"
  },
  {
    id: "2025-q3",
    year: 2025,
    quarter: "Q3",
    date: "Jan – Mar 2025",
    pages: 4,
    title: "A Quarter of Notable Growth",
    abstract: "“The only limit to our realization of tomorrow is our doubts of today.” Textile exports rose 15.9% year-on-year, reaching $1.69 billion in January.",
    authors: "Hassan Ali & Bilal Arshad",
    image: "/img/reports/2025-q1.jpg",
    file: "/reports/softwood-management-report-2025-q1.pdf"
  },
  {
    id: "2025-q2",
    year: 2025,
    quarter: "Q2",
    date: "Oct – Dec 2024",
    pages: 6,
    title: "Low Cotton Productivity & Local Market Trends",
    abstract: "Cotton production fell 33% year-on-year to 5.45 million bales, reshaping local market dynamics and driving spinners toward higher-quality sourcing.",
    authors: "Mudassar Ali & Waqar Ahmed",
    image: "/img/reports/2024-q4.jpg",
    file: "/reports/softwood-management-report-2024-q4.pdf"
  },
  {
    id: "2025-q1",
    year: 2025,
    quarter: "Q1",
    date: "Jul – Sep 2024",
    pages: 6,
    title: "International Outlook: Navigating Global Uncertainty",
    abstract: "A candid read on the international landscape — geopolitics, the Russia–Ukraine war, and their ripple effects on global textile demand and pricing.",
    authors: "Hasan Sharif & Firasat Noor",
    image: "/img/reports/2024-q3.jpg",
    file: "/reports/softwood-management-report-2024-q3.pdf"
  },
  {
    id: "2024-q4",
    year: 2024,
    quarter: "Q4",
    date: "Apr – Jun 2024",
    pages: 6,
    title: "Economic Prospects: Signs of Stability",
    abstract: "“The best way to predict your future is to create it.” The import bill fell 8.35% while exports edged upward — early signals of a stabilizing economy.",
    authors: "Muhammad Sabeeh ul Hassan",
    image: "/img/reports/2024-q2.jpg",
    file: "/reports/softwood-management-report-2024-q2.pdf"
  },
  {
    id: "2024-q3",
    year: 2024,
    quarter: "Q3",
    date: "Jan – Mar 2024",
    pages: 5,
    title: "Fabric Market Dynamics: Challenges & Fluctuations",
    abstract: "“Pressure is nothing more than the shadow of great opportunity.” A close look at the volatility in the export fabric market through the first quarter.",
    authors: "Tanveer Hassan",
    image: "/img/reports/2024-q1.jpg",
    file: "/reports/softwood-management-report-2024-q1.pdf"
  },
  {
    id: "2024-q2",
    year: 2024,
    quarter: "Q2",
    date: "Oct – Dec 2023",
    pages: 4,
    title: "Textile Exports Improve as Energy Costs Loom",
    abstract: "Improvement in textile exports shows potential for future growth, but rising production costs from the energy crisis continue to loom over the sector.",
    authors: "Bilal Arshad & Usman Sarwar",
    image: "/img/reports/2023-q4.jpg",
    file: "/reports/softwood-management-report-2023-q4.pdf"
  },
  {
    id: "2024-q1",
    year: 2024,
    quarter: "Q1",
    date: "Jul – Sep 2023",
    pages: 6,
    title: "When the Going Gets Tough",
    abstract: "“When the going gets tough, the tough get going.” Reflecting on recovery after a year defined by flooding and disruption across the industry.",
    authors: "Mudassar Ali & Waqar Ahmad",
    image: "/img/reports/2023-q3.jpg",
    file: "/reports/softwood-management-report-2023-q3.pdf"
  },
  {
    id: "2023-q4",
    year: 2023,
    quarter: "Q4",
    date: "Apr – Jun 2023",
    pages: 3,
    title: "May You Live in Interesting Times",
    abstract: "“There is an ancient Chinese curse: may you live in interesting times.” On turning market problems into opportunity amid uncertainty.",
    authors: "Hasan Sharif & Firasat Noor",
    image: "/img/reports/2023-q2.jpg",
    file: "/reports/softwood-management-report-2023-q2.pdf"
  }
];
